// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FolderOutlinedSvg from "@ant-design/icons-svg/lib/asn/FolderOutlined";
import AntdIcon from "../components/AntdIcon";
const FolderOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FolderOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    FolderOutlined.displayName = "FolderOutlined";
}
export default /*#__PURE__*/ React.forwardRef(FolderOutlined);
